import React from 'react';
import { getAllISOCodes } from 'iso-country-currency';

import { SingleSelect, SingleSelectProps } from 'components/SingleSelect/SingleSelect';

export const GooderaCountryPicker = (props: Omit<SingleSelectProps, 'options'>) => {
  const countries = getAllISOCodes();
  const options = countries.map((currencyInfo) => ({
    id: currencyInfo.iso,
    name: currencyInfo.countryName,
  }));
  return <SingleSelect {...props} disableClearable options={options} />;
};
